import React, { useState } from "react";
import "../../App.css";
import { Auth } from '../../core/auth';
import { PolicyPage } from '../reports/PolicyPage';
import { OAuthButtons } from '../../components/OAuthButtons';
import { AuthLogo } from '../../components/AuthLogo';

function LoginPageV2({ onLogin, showToast, onForgot, onRegister: _onRegister, runSubmitting }) {
  const [identifier, setId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPolicy, setShowPolicy] = useState(false);

  const handleLogin = async () => {
    setError("");
    if (!identifier) { setError("Enter email or mobile number"); return; }
    if (!password) { setError("Enter your password"); return; }
    const login = async () => {
      const result = await Auth.login(identifier, password);
      if (result.error) { setError(result.error); return; }
      showToast(`Welcome back, ${result.user.name}!`, "success");
      onLogin(result.user);
    };
    if (runSubmitting) await runSubmitting('Signing you in…', login, 'auth');
    else await login();
  };

  if (showPolicy) return <PolicyPage onBack={() => setShowPolicy(false)} />;

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <AuthLogo size={72} />
          <div style={{ fontFamily: "'Fraunces',serif", fontSize: 26, marginBottom: 2 }}>Founders Bridge</div>
          <div style={{ fontSize: 12, color: "var(--muted)", letterSpacing: 1 }}>Secure Portal</div>
        </div>

        <div className="f-group" style={{ marginBottom: 14 }}>
          <label className="f-label">Email Address or Mobile Number</label>
          <input className="f-input" type="text" placeholder="your@email.com or 98xxxxxxxx" value={identifier} onChange={e => setId(e.target.value)} onKeyDown={e => e.key === "Enter" && handleLogin()} autoFocus />
        </div>

        <div className="f-group" style={{ marginBottom: 8 }}>
          <label className="f-label">Password</label>
          <input className="f-input" type="password" placeholder="Enter your password" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === "Enter" && handleLogin()} />
        </div>

        <div style={{ textAlign: "right", marginBottom: 16 }}>
          <span style={{ fontSize: 12, color: "var(--blue)", cursor: "pointer", fontWeight: 600 }} onClick={onForgot}>Forgot password?</span>
        </div>

        {error && <div style={{ fontSize: 12, color: "var(--red)", marginBottom: 12, padding: "8px 12px", background: "#FFF1F2", borderRadius: 6 }}>{error}</div>}

        <button className="btn btn-primary btn-lg" style={{ width: "100%" }} onClick={handleLogin}>
          Sign In →
        </button>

        <OAuthButtons mode="login" onError={setError} />

        <div style={{ marginTop: 12, padding: "10px 14px", background: "#F9FAFB", border: "1px solid var(--border)", borderRadius: 8, fontSize: 11, color: "var(--muted)", lineHeight: 1.6, textAlign: "center" }}>
          For existing Founders Bridge clients only. Contact your account manager for access.
        </div>

        <div style={{ marginTop: 12, padding: "12px 14px", background: "#F9FAFB", border: "1px solid var(--border)", borderRadius: 8, fontSize: 11, color: "var(--muted)", lineHeight: 1.7 }}>
          By signing in, you agree to our{" "}
          <span style={{ color: "var(--blue)", cursor: "pointer", textDecoration: "underline" }} onClick={() => setShowPolicy(true)}>Terms of Service & Privacy Policy</span>.
        </div>
      </div>
    </div>
  );
}

export { LoginPageV2 };
